

import { useLoggedGeladaMutation } from '@netfront/gelada-identity-library';

import { UPDATE_CONTACT } from './useUpdateGroupContact.graphql';
import {
  IUseUpdateGroupContact,
  IUpdateGroupContactMutationGraphQLResponse,
  IUseUpdateGroupContactOptions,
  IUpdateGroupContactMutationVariables,
  IHandleUpdateGroupContactParams,
} from './useUpdateGroupContact.interfaces';

const useUpdateGroupContact = (options?: IUseUpdateGroupContactOptions): IUseUpdateGroupContact => {
  const { mutation, onCompleted, onError, product, tokens } = options ?? ({} as IUseUpdateGroupContactOptions);

  const [executeUpdateGroupContact, { loading: isLoading }] = useLoggedGeladaMutation<
    IUpdateGroupContactMutationGraphQLResponse,
    IUpdateGroupContactMutationVariables
  >({
    mutation: mutation ?? UPDATE_CONTACT,
    options: {
      onCompleted: ({
        user: {
          updateUserAsAdmin: isCompleted,
        },
      }) => {
        if (!onCompleted) {
          return;
        }

        onCompleted({
          isCompleted,
        });
      },
      onError,
    },
    product,
    tokens,
  });

  const handleUpdateGroupContact = async ({
    communityName,
    email,
    firstname,
    lastname,
    phoneNumber,
    phoneNumberCountryCode,
    userId,
  }: IHandleUpdateGroupContactParams) => {
    await executeUpdateGroupContact({
      variables: {
        communityName,
        email,
        firstname,
        lastname,
        phoneNumber,
        phoneNumberCountryCode,
        userId,
      },
    });
  };

  return {
    handleUpdateGroupContact,
    isLoading,
  };
};

export { useUpdateGroupContact };
